import { AppTooltip, IconButton, Badge } from '@components'
import { Button, Text } from '@here/components'
import { A } from '@solidjs/router'
import { ArrowRight, Bell, BellOff } from 'lucide-solid'
import { type Component, createEffect, For, Show } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Box, Flex, Grid } from 'styled-system/jsx'
import { useChannelsReads } from '../../../state/channelReads/state'
import { useSelectors } from '../../../state/selectors'
import { UnreadCount } from '../UnreadCount'

const style = css({
	'& button': {
		borderColor: 'tscGreen.10',
	},
})

const ChannelSetups: Component<{ height?: string; isMinimal?: boolean }> = (props) => {
	const { setupChannels } = useService(useSelectors)()
	const { toggleSubscribed, channelReadsRefetch, channelSeenResource } =
		useService(useChannelsReads)()

	createEffect(() => {
		if (channelSeenResource.state === 'ready') {
			channelReadsRefetch()
		}
	})

	return (
		<>
			<Flex
				overflow="auto"
				height={props.height || 'calc(50vh - 81px)'}
				alignItems="stretch"
				gap={1}
				direction="column"
			>
				<For each={setupChannels().slice(0, 5)}>
					{(channel) => (
						<Grid
							gridTemplateColumns="1fr auto"
							gap={1}
						>
							<A
								href={`/chat/${channel.setup.id}`}
								activeClass={style}
							>
								<Button
									display="grid"
									gridTemplateColumns="auto 1fr auto"
									alignItems="center"
									colorPalette="bg"
                  gap={1}
									size="xs"
									variant={props.isMinimal ? 'link' : 'outline'}
									_hover={{ color: props.isMinimal ? 'tscGreen.emphasized' : '' }}
									width="100%"
								>
									<Badge
										variant="subtle"
										size="sm"
										children={channel.setup.symbol}
									/>
									<AppTooltip
                    delay={1300}
										className={css({
											minW: 0,
											p: 1,
										})}
										content={channel.setup.title}
										openDelay={4000}
									>
										<Text
											textAlign="left"
											whiteSpace="nowrap"
											overflow="hidden"
											textOverflow="ellipsis"
										>
											{channel.setup.title}
										</Text>
									</AppTooltip>
									<Show when={channel.unreadCount}>
										<UnreadCount
											lastReadAt={channel.unreadCount}
											channelId={channel.id}
										/>
									</Show>
								</Button>
							</A>
							<Show when={!props.isMinimal}>
								<Flex gap={1}>
									<IconButton
										size="xs"
										colorPalette={channel.isSubscribed ? 'tscGreen' : 'fg'}
										variant="subtle"
										onClick={() => toggleSubscribed(channel.id)}
									>
										<Show
											when={channel.isSubscribed}
											fallback={<BellOff />}
										>
											<Bell />
										</Show>
									</IconButton>
									<A href={`/setups/${channel.setup.id}`}>
										<IconButton
											size="xs"
											variant="subtle"
										>
											<ArrowRight />
										</IconButton>
									</A>
								</Flex>
							</Show>
						</Grid>
					)}
				</For>
			</Flex>
		</>
	)
}

export default ChannelSetups
